export enum AccountStatus {
  New = 'New',
  Pending = 'Pending',
  Active = 'Active',
  Suspended = 'Suspended',
  Revoked = 'Revoked'
}
